import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product/trial/:id',
    name: 'TrialDetail',
    component: () => import('@/views/ProductDetail.vue'),
    props: { type: 'trial' }
  },
  {
    path: '/product/official/:id',
    name: 'OfficialDetail',
    component: () => import('@/views/ProductDetail.vue'),
    props: { type: 'official' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
